import React from "react";
import { motion } from "framer-motion";

/* Planets */
import binance from "../assets/binance.svg";
import bitcoin from "../assets/bitcoin.svg";
import ethereum from "../assets/ethereum.svg";
import avalanche from "../assets/avalanche.svg";
import xrp from "../assets/XRP.svg";
import polygon from "../assets/polygon.svg";
import solana from "../assets/solana.svg";
import stable from "../assets/stable.svg";

function Space() {
  const planets = [
    {
      name: "Binance",
      src: binance,
    },
    {
      name: "Bitcoin",
      src: bitcoin,
    },
    {
      name: "Ethereum",
      src: ethereum,
    },
    {
      name: "Avalanche",
      src: avalanche,
    },
    {
      name: "XRP",
      src: xrp,
    },
    {
      name: "Polygon",
      src: polygon,
    },
    {
      name: "Solana",
      src: solana,
    },
    {
      name: "Stable",
      src: stable,
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95, y: 10 }}
      whileInView={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      viewport={{ once: true }}
      className="space"
    >
      {/* System */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 1440 1223"
      >
        <path
          stroke="url(#paint0_linear_506_705)"
          d="M752.167 626.347c-6.262 24.727-23.787 45.399-50.2 61.595-26.415 16.197-61.692 27.898-103.38 34.682-83.375 13.566-192.295 7.446-306.99-21.598-114.694-29.045-213.4-75.503-280.269-127.116-33.435-25.807-58.89-52.888-74.413-79.705-15.521-26.815-21.096-53.336-14.834-78.064 6.262-24.728 23.787-45.399 50.2-61.595 26.415-16.198 61.692-27.899 103.38-34.682 83.374-13.566 192.295-7.446 306.99 21.598 114.694 29.045 213.4 75.503 280.269 127.116 33.435 25.807 58.891 52.887 74.413 79.705 15.521 26.815 21.096 53.336 14.834 78.064z"
        ></path>
        <path
          stroke="url(#paint1_linear_506_705)"
          d="M940.372 674.006c-9.117 36.001-34.628 66.079-73.038 89.631-38.413 23.554-89.698 40.563-150.286 50.421-121.175 19.717-279.461 10.821-446.127-31.384-166.666-42.206-310.109-109.718-407.294-184.731-48.594-37.507-85.603-76.874-108.176-115.872-22.571-38.994-30.692-77.589-21.575-113.59 9.117-36.001 34.628-66.079 73.038-89.631 38.413-23.554 89.698-40.562 150.286-50.421 121.174-19.717 279.461-10.821 446.127 31.385 166.666 42.205 310.109 109.717 407.294 184.73 48.594 37.507 85.603 76.875 108.175 115.872 22.572 38.995 30.693 77.589 21.576 113.59z"
        ></path>
        <path
          stroke="url(#paint2_linear_506_705)"
          d="M1169.38 732c-12.59 49.718-47.82 91.241-100.82 123.745-53.02 32.506-123.781 55.971-207.367 69.572-167.17 27.202-385.525 14.927-615.431-43.292-229.905-58.22-427.785-151.351-561.86-254.837-67.039-51.744-118.106-106.062-149.257-159.88-31.15-53.816-42.37-107.101-29.78-156.82 12.591-49.718 47.82-91.242 100.828-123.745 53.011-32.506 123.776-55.972 207.362-69.572 167.17-27.202 385.525-14.928 615.431 43.292 229.905 58.22 427.785 151.35 561.86 254.837 67.034 51.744 118.104 106.062 149.254 159.88 31.15 53.816 42.37 107.101 29.78 156.82z"
        ></path>
        <path
          stroke="url(#paint3_linear_506_705)"
          strokeWidth="1.227"
          d="M1354.36 779.639c-15.44 60.981-58.65 111.91-123.67 151.776-65.02 39.869-151.81 68.645-254.332 85.335-205.036 33.36-472.852 18.3-754.835-53.103C-60.46 892.24-303.162 778.014-467.608 651.086c-82.223-63.465-144.858-130.087-183.066-196.096-38.205-66.005-51.967-131.361-36.525-192.341 15.443-60.981 58.651-111.91 123.667-151.776 65.019-39.869 151.814-68.65 254.333-85.331C-104.162-7.821 163.654 7.233 445.636 78.64c281.983 71.407 524.685 185.633 689.134 312.561 82.22 63.465 144.86 130.087 183.06 196.096 38.21 66.005 51.97 131.361 36.53 192.341z"
        ></path>
        <path
          fill="#000"
          d="M232.655 734.734C97.535 674.575 36.519 516.831 96.37 382.403c59.851-134.428 217.906-194.634 353.025-134.475 135.12 60.159 196.137 217.902 136.286 352.33-59.852 134.428-217.906 194.635-353.026 134.476z"
        ></path>
        <path
          className="planetSystem"
          fill="url(#paint4_linear_506_705)"
          d="M232.655 734.734C97.535 674.575 36.519 516.831 96.37 382.403c59.851-134.428 217.906-194.634 353.025-134.475 135.12 60.159 196.137 217.902 136.286 352.33-59.852 134.428-217.906 194.635-353.026 134.476z"
        ></path>
        <defs>
          <linearGradient
            id="paint0_linear_506_705"
            x1="-49.298"
            x2="670.037"
            y1="401.76"
            y2="700.187"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#484848"></stop>
            <stop offset="0.491" stopColor="#484848" stopOpacity="0.36"></stop>
            <stop offset="1" stopColor="#484848"></stop>
          </linearGradient>
          <linearGradient
            id="paint1_linear_506_705"
            x1="-224.321"
            x2="820.824"
            y1="347.642"
            y2="781.236"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#484848"></stop>
            <stop offset="0.491" stopColor="#484848" stopOpacity="0.36"></stop>
            <stop offset="1" stopColor="#484848"></stop>
          </linearGradient>
          <linearGradient
            id="paint2_linear_506_705"
            x1="-437.291"
            x2="1004.3"
            y1="281.791"
            y2="879.857"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#484848"></stop>
            <stop offset="0.491" stopColor="#484848" stopOpacity="0.36"></stop>
            <stop offset="1" stopColor="#484848"></stop>
          </linearGradient>
          <linearGradient
            id="paint3_linear_506_705"
            x1="-616.252"
            x2="1151.89"
            y1="227.452"
            y2="960.989"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#484848"></stop>
            <stop offset="0.491" stopColor="#484848" stopOpacity="0.36"></stop>
            <stop offset="1" stopColor="#484848"></stop>
          </linearGradient>
          <linearGradient
            id="paint4_linear_506_705"
            x1="827.724"
            x2="364.343"
            y1="334.355"
            y2="511.733"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff"></stop>
            <stop offset="0.917" stopColor="#fff" stopOpacity="0.151"></stop>
            <stop offset="1" stopColor="#61B1FB" stopOpacity="0"></stop>
          </linearGradient>
        </defs>
      </svg>
      {/* /System */}
      {/* Planets */}

      {/* /Planets */}

      {planets.map((planet, index) => (
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: index * 0.5 + 0.3 }}
          viewport={{ once: true }}
          className={planet.name + " planet"}
          key={index}
        >
          <span className="namePlanet">{planet.name}</span>
          <object type="image/svg+xml" data={planet.src} key={index}>
            {planet.name}
          </object>
        </motion.div>
      ))}
    </motion.div>
  );
}

export default Space;
